import * as t from 'io-ts';
import { ErrorMessageDynamicType } from './errorMessage';

export const ValidationErrorDynamicType = t.interface({
    message: t.string,
});
const ValidationErrorsDynamicType = t.dictionary(t.string, t.array(ValidationErrorDynamicType));

const RequiredErrorDetails = t.interface({
    message: ErrorMessageDynamicType,
});
const OptionalErrorDetails = t.partial({
    validationErrors: ValidationErrorsDynamicType,
    invalidSharingTokens: t.array(t.string),
});

// Intersection of these types creates a new type, while keeping the required (interface) properties required
// and optional (partial) properties optional.
export const ErrorDetailsDynamicType = t.intersection([
    RequiredErrorDetails,
    OptionalErrorDetails]);

export type ValidationError = t.TypeOf<typeof ValidationErrorDynamicType>;
export type ValidationErrors = t.TypeOf<typeof ValidationErrorsDynamicType>;
export type ErrorDetails = t.TypeOf<typeof ErrorDetailsDynamicType>;
